import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8639f30e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-editor-header" }
const _hoisted_2 = { class: "history" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 撤销")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 重做")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 退出编辑")

import { PropType } from 'vue'
import { storeToRefs } from 'pinia'
import { useSnapshotStore } from '@/store'
import { Mode } from '@/types/mobile'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
  changeMode: {
    type: Function as PropType<(mode: Mode) => void>,
    required: true,
  },
},
  setup(__props) {



const { canUndo, canRedo } = storeToRefs(useSnapshotStore())
const { redo, undo } = useHistorySnapshot()

return (_ctx: any,_cache: any) => {
  const _component_IconBack = _resolveComponent("IconBack")!
  const _component_IconNext = _resolveComponent("IconNext")!
  const _component_IconLogout = _resolveComponent("IconLogout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["history-item", { 'disable': !_unref(canUndo) }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(undo)()), ["stop"]))
      }, [
        _createVNode(_component_IconBack),
        _hoisted_3
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["history-item", { 'disable': !_unref(canRedo) }]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(redo)()), ["stop"]))
      }, [
        _createVNode(_component_IconNext),
        _hoisted_4
      ], 2)
    ]),
    _createElementVNode("div", {
      class: "back",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.changeMode('preview')))
    }, [
      _createVNode(_component_IconLogout),
      _hoisted_5
    ])
  ]))
}
}

})